module.exports = __webpack_public_path__ + "img/App_Shop_Download.d65366c2.png";